<div class="mt-2" style="text-align: center;">
    <span>{{ 'COMMON.LOG_IN_DESCRIPCION' | translate }}</span>
  </div>
  <div class="mt-2" style="text-align: center;">
    <span>{{ 'COMMON.LOG_IN_DESCRIPCION_2' | translate }} <strong>alopez@diputaciónavila.es</strong></span>
  </div>
